module.exports = "/images/subcategories.svg";